import { FC } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { colors, radii } from '../../theme/tokens';
import { imageSrc } from './api';
import { DocumentPage } from './types';

// Thumbnail of a page. Images are shown from `image_url`; a PDF
// is not rasterised (the backend does not generate thumbnails yet — ROADMAP.md, M1),
// so it is represented with an icon. Without a page (upload in progress), the
// generic file icon.

type Props = {
  page?: DocumentPage;
  alt: string;
  size?: number;
  sx?: SxProps<Theme>;
};

export const isPdf = (page?: DocumentPage): boolean =>
  page?.mime_type === 'application/pdf';

const PageThumbnail: FC<Props> = ({ page, alt, size = 56, sx }) => (
  <Box
    sx={[
      {
        width: size,
        height: Math.round(size * 1.3),
        flex: '0 0 auto',
        borderRadius: `${radii.card}px`,
        overflow: 'hidden',
        backgroundColor: colors.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: colors.accent,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {page && !isPdf(page) ? (
      <img
        src={imageSrc(page.image_url)}
        alt={alt}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    ) : page ? (
      <PictureAsPdfOutlinedIcon
        titleAccess={alt}
        sx={{ fontSize: Math.round(size * 0.55) }}
      />
    ) : (
      <InsertDriveFileOutlinedIcon
        titleAccess={alt}
        sx={{ fontSize: Math.round(size * 0.55), color: colors.muted }}
      />
    )}
  </Box>
);

export default PageThumbnail;
